import {
    API_SUCCESS,
    API_FAIL,
    GET_CHARTS_DATA,
    GET_AID_REQUEST, 
    GET_AID_SUCCESS ,
    GET_AID_FAIL,
    GET_TOTALLABS_REQUEST, 
    GET_TOTALLABS_SUCCESS ,
    GET_TOTALLABS_FAIL,
    GET_TOTALEARNINGS_REQUEST, 
    GET_TOTALEARNINGS_SUCCESS ,
    GET_TOTALEARNINGS_FAIL,
    GET_TOTALCOMPLAINTS_REQUEST, 
    GET_TOTALCOMPLAINTS_SUCCESS ,
    GET_TOTALCOMPLAINTS_FAIL,
    GET_TOTALFA_REQUEST, 
    GET_TOTALFA_SUCCESS ,
    GET_TOTALFA_FAIL,
    GET_USERSTATS_REQUEST, 
    GET_USERSTATS_SUCCESS ,
    GET_USERSTATS_FAIL,
    
} from "./actionTypes";

const INIT_STATE = {
    chartsData: [],
    aid:[],
    totallabs:[],
    totalearning:[],
    totalcomplaints:[],
    userstats:[],
    totalfa:"",
    error: "",
    isLoading: false,


};

const Dashboard = (state = INIT_STATE, action) => {
    switch (action.type) {
        case API_SUCCESS:
            switch (action.payload.actionType) {
                case GET_CHARTS_DATA:
                    return {
                        ...state,
                        chartsData: action.payload.data
                    };

                default:
                    return state;
            }
            case  GET_AID_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_AID_SUCCESS:
            return {
                ...state,
                isLoading: false,
                aid: action.payload,
            };
        case GET_AID_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
            case  GET_TOTALLABS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_TOTALLABS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                totallabs: action.payload,
            };
        case GET_TOTALLABS_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
            case  GET_TOTALCOMPLAINTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_TOTALCOMPLAINTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                totalcomplaints: action.payload,
            };
        case GET_TOTALCOMPLAINTS_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
            case  GET_TOTALFA_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_TOTALFA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                totalfa: action.payload,
            };
        case GET_TOTALFA_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
            case  GET_USERSTATS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_USERSTATS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                userstats: action.payload,
            };
        case GET_USERSTATS_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case GET_TOTALEARNINGS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                totalearning: action.payload,
            };
        case GET_TOTALEARNINGS_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case API_FAIL:
            switch (action.payload.actionType) {
                case GET_CHARTS_DATA:
                    return {
                        ...state,
                        earningChartDataError: action.payload.error
                    };


                default:
                    return state;
                    
            }
        default:
            return state;
    }
}


export default Dashboard;